import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const RelatedCaseStudies = ({
  key,
  casestudies=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <>
      {casestudies &&
        <div className="case-study-module case-study-more-case-studies tease-items-block bgg1">
          <div className="df title mb3 jcc">
            <h2 className="content-title">More Case Studies</h2>
          </div>
          <div className="container">
            <div className="row jcc">
              {casestudies.map((casestudy, index) => (
                  <div className="col-12 col-sm-8 col-md-6 col-lg-3 list-item ph2">
                  <div className="list-content bgw br3 mb4 ofh bs1">
                    {casestudy.featuredImage &&
                      <Link href={ `/resource/${casestudy.slug}/` } title={ htmlDecode(casestudy.title) } className="dbha">
                        {casestudy.featuredImage.formats.medium &&
                          <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${casestudy.featuredImage.formats.medium.url.includes(cdnUrl) ? casestudy.featuredImage.formats.medium.url : cdnUrl + casestudy.featuredImage.formats.medium.url })`, opacity: 1}}/>
                        }
                        {!casestudy.featuredImage.formats.medium &&
                          <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${casestudy.featuredImage.url.includes(cdnUrl) ? casestudy.featuredImage.url : cdnUrl + casestudy.featuredImage.url}")`, opacity: 1}} />
                        }
                      </Link>
                    }
                    <div className="teaser-text-wrap">
                      <Link className="cat-btn" href="/resource-categories/case-study/" title="Case Study">Case Study</Link>
                      <Link href={ `/resource/${casestudy.slug}/` } title={ htmlDecode(casestudy.title) }>
                        <h3 className="teaser-header mt2 mb1.8">{ htmlDecode(casestudy.title) }</h3>
                      </Link>
                      <hr className="small orange mb1.8 ml0" />
                      <p className="copy">{ htmlDecode(casestudy.content).substr(0, 80) }&hellip;</p>
                      <Link className="button uppercase" href={ `/resource/${casestudy.slug}/` } title={ htmlDecode(casestudy.title) }>View Case Study</Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default RelatedCaseStudies
